import React, { useState, useEffect } from 'react'
import TestimonialCard from '../../../components/common/TestimonialCards/TestimonialCard'
import BgImage from '../../../assets/testimonial-bg.jpg'
import { useTestimonialList } from '../api'
import { useAuthStore } from '../../../store/authStore'
const TestimonialSlider = () => {
  const { language } = useAuthStore()
  const [current, setCurrent] = useState(0)
  const { data, isLoading, isError } = useTestimonialList()

  // Use only the latest 5 testimonials (assumes API returns chronological order)
  const allTestimonials = Array.isArray(data) ? data : []
  const testimonials = allTestimonials.slice(-5)

  // Auto-advance timer and clamp current index when list changes
  useEffect(() => {
    if (!testimonials.length) return

    // Ensure current index is within new bounds if testimonials changed length
    setCurrent((prev) => Math.min(prev, testimonials.length - 1))
    setCurrent((prev) => (prev >= testimonials.length ? 0 : prev))

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [testimonials])

  if (isLoading) {
    return (
      <section className="py-12 px-4">
        <p>Loading testimonials...</p>
      </section>
    )
  }

  if (isError) {
    return (
      <section className="py-12 px-4">
        <p>Error loading testimonials.</p>
      </section>
    )
  }

  if (!testimonials.length) {
    return (
      <section className="py-12 px-4">
        <p>No testimonials found.</p>
      </section>
    )
  }
  return (
    <section className="bg-white py-12 px-1">
      <div className=" mb-10 lg:w-11/12 mx-auto">
        <h2 className="text-2xl font-semibold">
          {language === 'lang_mal' ? 'പരീക്ഷണങ്ങൾ' : 'Testimonials'}
        </h2>
        <p className="text-md text-gray-600">
          {language === 'lang_mal'
            ? 'നമ്മുടെ സന്തുഷ്ട ക്ലയന്റുകൾ പറയുന്നത്'
            : 'What Our Happy Clients Say'}
        </p>
      </div>

      <div
        className="lg:w-11/12 mx-auto rounded"
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="lg:py-10">
          <div className=" flex justify-center mx-auto transition-all duration-500 ease-in-out">
            <TestimonialCard {...testimonials[current]} />
          </div>

          <div className="flex justify-center mt-6 space-x-2">
            {testimonials.map((_: any, index: any) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-3 h-3 rounded-full ${
                  index === current ? 'bg-primaryBlue' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TestimonialSlider
